// TODO : Convert MUI Typography to Link and Icon when drawerOpen is true
// TODO : Add ToolTip to ThemeSwitch

import { AccountCircle as ProfileIcon } from '@mui/icons-material';
import { Avatar, IconButton, Stack, Typography } from '@mui/material';
import { AppBar, Toolbar } from 'components/styled/Header.styled';
import { SidebarMenuButton } from 'components/design';
import useController from 'components/layout/header/header-controller';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { ToolTip } from 'components/controls';
import { WorkspaceModal } from '../workspace-modal/workspace-modal';
import { useWorkspace } from 'hooks/useWorkspace';
import { ProfilePopover } from '../profile-popover';

export const AccountMenu = ({
    account,
    logout,
    openChangeWorkspace,
    websiteName,
    isProfileOpen,
    handleCloseProfile,
    handleOpenProfile,
    anchorEl,
}) => {
    const { singleWebsite } = useWorkspace();

    return (
        <Stack direction="row" spacing={1.75} justifyContent="center" alignItems="center">
            <>
                <Stack direction="row">
                    <ToolTip title="Change workspace" disableHoverListener={singleWebsite}>
                        <IconButton
                            color="default"
                            sx={{
                                '&:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            aria-label="settings"
                            onClick={openChangeWorkspace}
                            disabled={singleWebsite}
                        >
                            <SettingsIcon />
                        </IconButton>
                    </ToolTip>
                    <Typography
                        sx={{
                            fontSize: '0.9rem',
                            alignContent: 'center',
                        }}
                    >
                        {websiteName}
                    </Typography>
                </Stack>
            </>

            <Avatar onClick={handleOpenProfile} sx={{ cursor: 'pointer' }}>
                <ProfileIcon />
            </Avatar>
            <ProfilePopover
                isProfileOpen={isProfileOpen}
                anchorEl={anchorEl}
                handleCloseProfile={handleCloseProfile}
                logout={logout}
                account={account}
            />
        </Stack>
    );
};

/**
 * Header
 */
const Header = () => {
    const {
        username,
        role,
        isSuccess,
        handleLogout,
        handleDrawerClick,
        drawerOpen,
        handleOpenChangeWorkspace,
        handleCloseChangeWorkspace,
        handleOpenProfile,
        handleCloseProfile,
        isChangeWorkspaceOpen,
        isProfileOpen,
        anchorEl,
    } = useController();

    const { websiteName, singleWebsite } = useWorkspace();

    return (
        <>
            <AppBar
                sx={drawerOpen ? { alignItems: 'flex-end' } : {}}
                elevation={0}
                component="div"
                open={drawerOpen}
                data-testid="app-bar"
            >
                <Toolbar>
                    <SidebarMenuButton drawerOpen={drawerOpen} onClick={handleDrawerClick} />
                    {isSuccess && (
                        <>
                            <AccountMenu
                                account={{
                                    username,
                                    role,
                                }}
                                logout={handleLogout}
                                openChangeWorkspace={handleOpenChangeWorkspace}
                                websiteName={websiteName}
                                handleCloseProfile={handleCloseProfile}
                                handleOpenProfile={handleOpenProfile}
                                isProfileOpen={isProfileOpen}
                                anchorEl={anchorEl}
                            />
                        </>
                    )}
                </Toolbar>
            </AppBar>
            {!singleWebsite && (
                <WorkspaceModal handleOpen={isChangeWorkspaceOpen} handleClose={handleCloseChangeWorkspace} />
            )}
        </>
    );
};

export default Header;
